var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 15.0834,
    transform: "translate(1.83301 0.25)",
    fill: "#086EA1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74976 1V2.00004H2.83301C2.28072 2.00004 1.83301 2.44776 1.83301 3.00004V4.33337V14.3334C1.83301 14.8857 2.28072 15.3334 2.83301 15.3334H14.1663C14.7186 15.3334 15.1663 14.8857 15.1663 14.3334V4.33337V3.00004C15.1663 2.44776 14.7186 2.00004 14.1663 2.00004H13.2498V1C13.2498 0.585786 12.914 0.25 12.4998 0.25C12.0855 0.25 11.7498 0.585786 11.7498 1V2.00004H5.24976V1C5.24976 0.585786 4.91397 0.25 4.49976 0.25C4.08554 0.25 3.74976 0.585786 3.74976 1ZM14.1663 5.33337H2.83301V14.3334L14.1663 14.3334V5.33337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c2fc04be94cf4108c9625880bc3bb904.svg";
export { ForwardRef as ReactComponent };